module.exports = __webpack_public_path__ + "static/img/index_ad.fd5b781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/index_ad.png
// module id = CVDb
// module chunks = 192